<template>
    <div>
        <div class="tb">
            <div class="tb-elements">
                <v-toolbar-title class="ml-4">
                    <v-icon v-if="icon" style="width: 2rem" size="small" color="white">{{
                        icon
                    }}</v-icon>
                    <span :class="icon ? 'ml-4' : ''">{{ title }}</span>
                </v-toolbar-title>
                <div class="mr-4">
                    <slot name="controls"></slot>
                </div>
            </div>
        </div>
        <div class="extension">
            <div class="extension-elements">
                <slot name="extension"></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const { title, icon } = defineProps<{ title: string; icon?: string }>()
</script>

<style lang="scss" scoped>
.tb {
    height: 4rem;
    --v-theme-overlay-multiplier: var(--v-theme-primary-overlay-multiplier);
    background-color: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
}

.tb-elements {
    display: flex;
    max-width: 100rem;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    height: 100%;
}

.extension {
    --v-theme-overlay-multiplier: var(--v-theme-primary-overlay-multiplier);
    background-color: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
}

.extension-elements {
    display: flex;
    max-width: 100rem;
    margin: auto;
}
</style>
